import { render, staticRenderFns } from "./SubmitCanceled.vue?vue&type=template&id=4e19f1e6&"
import script from "./SubmitCanceled.vue?vue&type=script&lang=js&"
export * from "./SubmitCanceled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports